import React from 'react';

function Panel({ title, sub, live = false, linkText, onLink, actions, noPad = false, className = '', children }) {
  return (
    <div className={`panel ${className}`}>
      {(title || actions || onLink) && (
        <div className="panel-header">
          {title && (
            <h3 className="panel-title">
              {live && <span className="dot-live" />}
              {title}
              {sub && <span className="panel-sub">{sub}</span>}
            </h3>
          )}
          {onLink && (
            <a
              className="panel-link"
              href="#view-all"
              onClick={(e) => { e.preventDefault(); onLink(); }}
            >
              {linkText || 'View all'}
            </a>
          )}
          {actions}
        </div>
      )}
      <div className={`panel-body${noPad ? ' no-pad' : ''}`}>{children}</div>
    </div>
  );
}

export default Panel;
